import * as React from "react";
import { Button } from "antd";
import { BrowserFooterProps } from "../types";
import styles from "../NGProviderBrowser.module.scss";

export const BrowserFooter: React.FC<BrowserFooterProps> = React.memo(
  ({ selectedCount, multipleChoice, onCancel, onOk, disabled }) => {
    const selectionText = React.useMemo(() => {
      if (selectedCount === 0) return "No items selected";
      if (selectedCount === 1) return "1 item selected";
      return `${selectedCount} items selected`;
    }, [selectedCount]);

    return (
      <div className={styles.footer}>
        <span className={styles.selectionCount}>{multipleChoice ? selectionText : null}</span>
        <div className={styles.footerButtons}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" onClick={onOk} disabled={disabled}>
            OK
          </Button>
        </div>
      </div>
    );
  },
);

BrowserFooter.displayName = "BrowserFooter";
